// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2lT9Q","search":"Settings_search__mcxSS","filter":"Settings_filter__2n02Y"};